import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { Chip, Text } from '@reveni-io/reveni-ui'

import { getItemStatusChips, itemStatusLabels } from './constants'
import { getItemLabel } from './helpers'
import * as Styles from './styles'

const ShipmentItemsList = ({ items }) => {
  const { t } = useTranslation()
  const theme = useTheme()
  const itemStatusChips = getItemStatusChips(theme)

  return (
    <Styles.Container>
      <Text type="titleS">{t('Artículos incluidos en el envío ({{count}})', { count: items.length })}</Text>
      <Styles.List>
        {items.map(item => {
          return (
            <Styles.Item key={item.id}>
              <Styles.ItemContent>
                <Text type="bodyMRegular">{getItemLabel(item)}</Text>
                <Chip
                  Icon={itemStatusChips[item.status]?.Icon}
                  label={t(itemStatusLabels[item.status])}
                  backgroundColor={itemStatusChips[item.status]?.backgroundColor}
                  color={itemStatusChips[item.status]?.color}
                />
              </Styles.ItemContent>
            </Styles.Item>
          )
        })}
      </Styles.List>
    </Styles.Container>
  )
}

export default ShipmentItemsList
